import { useEffect } from 'react';
import { MESSAGE_TYPES } from '../constants/simulationConstants';
import { normalizeStructuredUserEmotion } from '../helpers/userEmotion';
import { useSimulationContext } from '../providers/SimulationProvider';

function useCoreRequestedUserEmotionListener(isEmotionRecognitionEnabled) {
  const { setUserEmotion, setIsEmotionDetectionReady } = useSimulationContext();

  useEffect(() => {
    if (!isEmotionRecognitionEnabled) return undefined;

    const handleMessage = (event) => {
      try {
        let receivedData = event.data;

        if (typeof receivedData === 'string') {
          try {
            receivedData = JSON.parse(receivedData);
          } catch {
            return;
          }
        }

        if (receivedData.type !== MESSAGE_TYPES.REQUEST_USER_EMOTION) return;

        const structuredEmotion = normalizeStructuredUserEmotion(
          receivedData.payload?.emotion
        );

        if (!structuredEmotion) return;

        setUserEmotion(structuredEmotion);
        setIsEmotionDetectionReady(true);
      } catch (error) {
        console.error('[Core Emotion Listener Error]:', error);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [isEmotionRecognitionEnabled, setIsEmotionDetectionReady, setUserEmotion]);
}

export default useCoreRequestedUserEmotionListener;
